import imgix from "imgix.js";

export default class Imgix {
    constructor() {
        if (imgix.instance) {
            return imgix.instance;
        }
        imgix.instance = this;

        this.registeredEvents = new Set();
        this.init();
    }

    init = () => {
        document.querySelectorAll("img.imgix-fluid").forEach((img) => {
            this.applyImgixSrcSet(img);
        });

        document.querySelectorAll(".imgix-bg").forEach((el) => {
            this.applyBackgroundImage(el);
        });

        this.registerEvents(["revealOffcanvas", "ajaxModalHasLoaded"]);
    };

    applyImgixSrcSet = (img) => {
        const imagePath = img.dataset.src;
        const ixParams = JSON.parse(img.getAttribute("ix-params"), (key, value) => {
            // Don't allow null parameters
            return value != null ? value : undefined;
        });
        const parameters = Object.assign({"fit":"crop", "crop":"faces"}, ixParams)

        // Build the query string
        const paramsString = new URLSearchParams(parameters).toString(); // focal point
        const finalUrl = `${imagePath}${
            imagePath.includes("?") ? "&" : "?"
        }${paramsString}`;

        // Define widths for the srcset
        const imgWidth = img.offsetWidth || img.parentElement?.offsetWidth || 800;
        const imgHeight = img.offsetHeight || img.parentElement?.offsetHeight || 800;
        const devicePixelRatio = window.devicePixelRatio || 1;
        const aspectRatio = imgHeight / imgWidth;
        const widths = [360, 420, 640, 768, 900, 1024, 1280, 1440, 1600, 2000]; // srcset sizes to be generated
        const dimensions = (width) => {
            let value = `&w=${width}`;
            if (!img.classList.contains("img-fit")) {
                value += `&h=${Math.round(width * aspectRatio)}`;
            }
            return value + "&auto=compress,format&strip=all";
        };

        // Create the srcset and fallback src
        img.srcset = widths
            .map((width) => `${finalUrl}${dimensions(width)} ${width}w`)
            .join(", ");
        img.src = `${finalUrl}&w=${imgWidth}&h=${imgHeight}&dpr=${devicePixelRatio}`; // Fallback src / noscript src
        img.sizes = `(max-width: 800px) 100vw, ${imgWidth}px`;
        img.loading = img.dataset.load; // Lazy / Eager

        // Add loaded class on load
        img.onload = () => img.classList.add("has-loaded");
    };

    applyBackgroundImage = (el) => {
        const imagePath = el.dataset.src;
        const backgroundImageUrl = `${imagePath}?fit=clip&auto=compress,format&strip=all`;

        // Apply as a background image
        el.style.backgroundImage = `url(${backgroundImageUrl})`;
    };

    registerEvents = (events) => {
        events.forEach((event) => {
            if (!this.registeredEvents.has(event)) {
                document.addEventListener(event, () => this.handleEvent());
                this.registeredEvents.add(event);
            }
        });
    };

    handleEvent = (scope = document) => {
        scope.querySelectorAll("img.imgix-fluid").forEach((img) => {
            this.applyImgixSrcSet(img);
        });

        scope.querySelectorAll(".imgix-bg").forEach((el) => {
            this.applyBackgroundImage(el);
        });
    };

    process = (el) => {
        if (el.classList.contains("imgix-fluid")) {
            this.applyImgixSrcSet(el);
        } else {
            this.handleEvent(el);
        }
    };
}

export const ixPolyfill = () => {
    window.addEventListener("load", () => {
        window.imgix = {
            fluid: () => {
                return false;
            },
        };
    });

    // Catch all jQuery 'trigger' events and dispatch a native event
    (function ($) {
        // Store the original jQuery trigger method
        const originalTrigger = $.fn.trigger;

        // Override the jQuery trigger method
        $.fn.trigger = function (eventType, extraParameters) {
            // Call the original trigger method first
            const result = originalTrigger.apply(this, arguments);

            // Ensure eventType is a string (in case it's an event object)
            const eventName =
                typeof eventType === "string" ? eventType : eventType.type;

            // Dispatch a native event
            this.each(function () {
                this.dispatchEvent(
                    new CustomEvent(eventName, {
                        bubbles: true,
                        detail: extraParameters,
                    })
                );
            });

            return result; // Maintain jQuery chaining
        };
    })(jQuery);
};
